export const createContestsEditionsStandingsRequests = (client) => ({
    listContestsEditionStandings: async (params) => {
        const { data, meta, links } = await client.api.get("contests_edition_standings", {
            params: params,
        });
        return { data, meta, links };
    },
    updateContestsEditionStandings: async (payload) => {
        const { data } = await client.api.request({
            type: "contests_edition_standings",
            url: "/contests_edition_standings",
            body: payload,
            method: "POST",
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map